var _defs, _mask, _use, _mask2, _use2, _mask3, _path, _mask4, _path2, _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCardBannerMcDocs = function SvgCardBannerMcDocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 80,
    viewBox: "0 0 324 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 0h1700v200H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M0 0h32v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M0 0h130v148H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M0 0h192v219H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    d: "M0 0h148v169H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.692%",
    x2: "100%",
    y2: "49.427%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#325A67",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#437889",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "a",
    x: 0,
    y: 0,
    width: 324,
    height: 80,
    rx: 6
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#078CDF",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-676 -28)"
  }, _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.143,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(752 42)"
  }, _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 28.213c0 .433-.235.833-.616 1.05l-14.768 6.575c-.381.216-.85.216-1.232 0L.616 29.263A1.21 1.21 0 0 1 0 28.213V7.788c0-.434.235-.834.616-1.05L15.384.162c.381-.217.85-.217 1.232 0l14.768 6.574c.381.217.616.617.616 1.05v20.426Z",
    fill: "#FFF",
    mask: "url(#g)"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.078,
    style: {
      mixBlendMode: "overlay"
    },
    transform: "translate(826 -97)"
  }, _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130 115.985c0 1.78-.954 3.426-2.502 4.317l-59.996 27.03a5.02 5.02 0 0 1-5.004 0l-59.996-27.03A4.981 4.981 0 0 1 0 115.985v-83.97c0-1.78.954-3.426 2.502-4.317L62.498.668a5.017 5.017 0 0 1 5.004 0l59.996 27.03A4.982 4.982 0 0 1 130 32.015v83.97Z",
    fill: "#FFF",
    mask: "url(#i)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.073,
    transform: "translate(713 45)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "k",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192 171.626a7.373 7.373 0 0 1-3.695 6.388l-88.61 39.998a7.403 7.403 0 0 1-7.39 0l-88.61-39.998A7.374 7.374 0 0 1 0 171.626V47.374a7.376 7.376 0 0 1 3.695-6.388L92.305.989a7.398 7.398 0 0 1 7.39 0l88.61 39.997A7.375 7.375 0 0 1 192 47.374v124.252Z",
    fill: "#FFF",
    mask: "url(#k)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(880 3)",
    opacity: 0.137
  }, /*#__PURE__*/React.createElement("mask", {
    id: "m",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M148 132.442a5.69 5.69 0 0 1-2.849 4.93l-68.303 30.866a5.701 5.701 0 0 1-5.696 0L2.848 137.37A5.691 5.691 0 0 1 0 132.442V36.558a5.693 5.693 0 0 1 2.848-4.93L71.152.763a5.697 5.697 0 0 1 5.696 0l68.303 30.865a5.693 5.693 0 0 1 2.849 4.93v95.884Z",
    fill: "#FFF",
    mask: "url(#m)"
  }))))))));
};

export default SvgCardBannerMcDocs;